var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ar-basic-organization-info-cell"},[_c('img',{staticClass:"ar-basic-organization-info-cell__logo",attrs:{"src":_vm.logoUrl}}),_vm._v(" "),_c('span',{staticClass:"ar-basic-organization-info-cell__name"},[_vm._v(_vm._s(_vm.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }